import { Icon } from '@chakra-ui/react';

export default function SFVideoFilled(props) {
  return (
    <Icon
      width='20px'
      height='13px'
      viewBox='0 0 20 13'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M2.5625 12.7031C0.992188 12.7031 0.0546875 11.7969 0.0546875 10.2266V2.48438C0.0546875 0.921875 1.0625 0.015625 2.5625 0.015625H11.0312C12.6016 0.015625 13.4609 0.921875 13.4609 2.48438V10.2266C13.4609 11.7969 12.5234 12.7031 10.9531 12.7031H2.5625ZM14.5234 8.66406V4.04688L17.3672 1.59375C17.6328 1.35938 17.9453 1.21094 18.2266 1.21094C18.8359 1.21094 19.2344 1.65625 19.2344 2.29688V10.4219C19.2344 11.0625 18.8359 11.5078 18.2266 11.5078C17.9453 11.5078 17.6328 11.3594 17.3672 11.125L14.5234 8.66406Z' />
    </Icon>
  );
}
